import { List, ListItem, ListItemText, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";

function SearchResultsList({ results: brands, onResultClick }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, [brands]);

  return (
    <Paper
      elevation={3}
      sx={{
        position: "absolute",
        width: "100%",
        zIndex: 1000,
        maxHeight: 200,
        overflowY: "auto",
      }}
    >
      {isOpen && (
        <List>
          {brands.map((brand, index) => (
            <ListItem
              button
              key={index}
              onClick={() => {
                onResultClick(brand.code, brand.name);
                setIsOpen(false);
              }}
            >
              <ListItemText primary={brand.name} />
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  );
}

export default SearchResultsList;
